import React from 'react';
import '../../../i18n';

import { withNamespaces } from 'react-i18next';
import style from './style';

const Presenter = ({ values, renderListItem,onUp,onDown}) => {
	return values.map((val,index) => {
		return (
			<style.Wrapper key={val}>
				<div>{renderListItem(val,index)}</div>
				<div><style.IconButton onClick={onUp(index)}><style.ArrowUpIcon/></style.IconButton></div>
				<div><style.IconButton onClick={onDown(index)}><style.ArrowDownIcon/></style.IconButton></div>
			</style.Wrapper>
		);
	});
};

Presenter.propTypes = {
};

export default withNamespaces()(Presenter);